module.exports = __webpack_public_path__ + "static/media/Bianca_Sissing_mood.36a60c59.jpg";